import React, { useEffect } from 'react';
import { Button, FormControl, Grid } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import LanguageUtils from '../../../utils/LanguageUtils';
import GenericTextField from '../../common/widgets/genericTextField';
import Action from '../../../interfaces/common/action';
import ActionRenderer from '../../common/actionRenderer';
import { useDispatch, useSelector } from 'react-redux';
import PageUtils from '../../../utils/pageUtils';
import { fetchOrderSources, getOrderSources } from '../../../reducers/orderSourceReducer';
import GenericAutocomplete from '../../common/widgets/genericAutocomplete';
import OrderSource from '../../../interfaces/output/orderSource';
import ReportHeader004Filters from '../../../interfaces/filters/reportHeader004Filters';

interface IFilterProps {
    filters: ReportHeader004Filters;
    onChange: any;
    applyFilters: any;
    setDefaultState: any;
    actions?: Array<Action>;
}

const messages = {
    departureYear: LanguageUtils.createMessage('year'),
    departureMonth: LanguageUtils.createMessage('month'),
    orderSource: LanguageUtils.createMessage('Order source'),
    resetFilters: LanguageUtils.createMessage('Reset filters'),
    applyFilters: LanguageUtils.createMessage('Apply filters')
};

export default function ReportHeaderFiltersComponent(props: IFilterProps): JSX.Element {
    const { filters, onChange, applyFilters, setDefaultState, actions } = props;
    const dispatch = useDispatch();
    const paging = PageUtils.getMaxPaging();
    const orderSources = useSelector(getOrderSources).content;

    useEffect(() => {
        dispatch(fetchOrderSources({ paging }));
    }, [dispatch]);

    return (
        <Grid container p={2} direction="column">
            <Grid item>
                <Grid container spacing={2} mt={1} justifyContent="flex-end">
                    <ActionRenderer actions={actions} />
                </Grid>
            </Grid>
            <Grid item>
                <Grid container spacing={2} mt={1} alignItems="flex-end">
                    <Grid item xs>
                        <FormControl fullWidth>
                            <GenericTextField<number>
                                name="year"
                                label={messages.departureYear}
                                onChange={onChange}
                                value={filters.departureYear}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs>
                        <FormControl fullWidth>
                            <GenericTextField<number>
                                name="month"
                                label={messages.departureMonth}
                                onChange={onChange}
                                value={filters.departureMonth}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs>
                        <GenericAutocomplete<OrderSource>
                            options={orderSources}
                            value={filters.fkOrderSource}
                            onChange={(obj: OrderSource | null) => onChange('fkOrderSource', obj?.id)}
                            placeholder={messages.orderSource}
                            compareFn={(o: OrderSource) => o.id === filters.fkOrderSource}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item>
                <Grid container spacing={2} mt={1} justifyContent="flex-end">
                    <Grid item>
                        <Button onClick={setDefaultState}><FormattedMessage {...messages.resetFilters} /></Button>
                    </Grid>
                    <Grid item>
                        <Button onClick={applyFilters}><FormattedMessage {...messages.applyFilters} /></Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}